module.exports = __webpack_public_path__ + "static/media/ACM-W-logo.ae6e1c44.png";